module.exports = __webpack_public_path__ + "static/media/kop_surat.ac7fbfdd.png";